import Reflux from "reflux";
const ActionCreators = {
  search: Reflux.createAction(),
  unindex: Reflux.createAction(),
  remove: Reflux.createAction()
};
export { ActionCreators };
